<h1 mat-dialog-title>
  Revoke Payroll
</h1>
<div mat-dialog-content>
  <div>
    Are you sure you want to revoke the payroll for
  </div>
  <div class="mb-3">
    <b>"{{data.detachmentName}}"</b>?
  </div>

  <div *ngIf="data.isApproved" class="alert alert-warning mb-3">
    <i class="fa-solid fa-triangle-exclamation"></i>
    This payroll has already been <b>Approved</b>. Revoking it will restore all deduction balances for the affected employees.
  </div>

  <div class="alert alert-danger">
    <i class="fa-solid fa-triangle-exclamation"></i>
    This will revoke all payslips for this detachment within the selected cutoff period.
  </div>

  <div *ngIf="data.isApproved" class="mt-3">
    <label class="form-label fw-semibold">
      Reason for revoking <span class="text-danger">*</span>
    </label>
    <textarea
      class="form-control"
      rows="3"
      placeholder="Enter the reason for revoking this approved payroll..."
      [(ngModel)]="comment"
      maxlength="500">
    </textarea>
    <div *ngIf="comment.trim().length === 0" class="text-danger small mt-1">
      A reason is required to revoke an approved payroll.
    </div>
  </div>
</div>
<div mat-dialog-actions class="mx-3">
  <button mat-raised-button mat-dialog-close class="mb-3">
    Cancel
  </button>
  <button mat-raised-button color="warn" (click)="onRevoke()" [disabled]="!canRevoke" class="mb-3">
    <i class="fa-solid fa-trash"></i> Yes, Revoke this payroll
  </button>
</div>
